import { render, staticRenderFns } from "./ActiveCourse.vue?vue&type=template&id=f60521be&"
import script from "./ActiveCourse.vue?vue&type=script&lang=js&"
export * from "./ActiveCourse.vue?vue&type=script&lang=js&"
import style0 from "./ActiveCourse.vue?vue&type=style&index=0&id=f60521be&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports